import { saltarFaceIdUnaVez } from './preferenciaBiometria';
import { esApp } from './plataforma';

/**
 * Al cerrar sesión, el login que viene detrás no pide la cara.
 *
 * Con Face ID activado, el login la pide al aparecer y entra solo: es lo que queremos al abrir la
 * app, pero no después de pulsar «Cerrar sesión», que volvía a entrar en bucle y no dejaba cambiar
 * de cuenta (simulador, 15-oct-2026). El acceso guardado no se borra: la próxima vez que se abra la
 * app, se podrá entrar con la cara.
 *
 * Solo en la app: en la web no hay Face ID y no se deja nada guardado.
 */
export const noEntrarConFaceIdTrasCerrarSesion = (): void => {
	if (!esApp()) {
		return;
	}

	saltarFaceIdUnaVez();
};
